import React from 'react'
import './style/circle.css';

export default function Circle() {
    return (
        <div className="lds-circle"><div></div></div>
    )
}
